import client from "./internal/httpClient";

export function userlist() {
  return client.post("/admin/userlist");
}

export function domainlist() {
  return client.post("/admin/domainlist", {});
}

export function register(data) {
  return client.post("/admin/register",data);
}
export function updateuser(data) {
  return client.post("/admin/updateuser",data);
}
export function deleteuser(data) {
  return client.post("/admin/deleteuser",data);
}
export const adminLogin = (data) => {
  return client.post('/admin/adminLogin',data);
};